<template>
    <div>
        <cityinfo-header></cityinfo-header>
            <div class="inner-banner">
                <section class="w3l-breadcrumb">
                    <div class="container py-md-4">
                        <div class="title-heading-w3 text-center mx-auto">
                            <h3 class="title-main">組織架構</h3>
                            <div class="mt-4 sub-title text-center">
                            </div>
                        </div>
                    </div>
                </section>
                <section class="w3l-contacts-12">
                    <div class="contact-top pt-5">
                        <div class="container py-md-4 py-3">
                            <div class="d-grid cont-main-top mt-5" style="grid-template-columns: none;">
                                <div class="contacts12-main ml-lg-4 mr-lg-4" v-if="fileBlob">
                                    <button type="button" class="btn btn-primary" @click="previewFile">預覽檔案</button>
                                </div>
                                <div class="row mt-md-5 mt-3">
                                    <div class="col-12 text-center">
                                        <div class="btn btn-style">
                                            <button type="button" class="btn" @click="$router.go(-1);">返回</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        <cityinfo-footer></cityinfo-footer>
    </div>
</template>
<script>
import header from "./header";
import footer from './footer';
export default {
    components:{
        "cityinfo-header":header,
    "cityinfo-footer":footer
    },
    data(){
        return {
            fileBlob:null,
        }
    },
    mounted(){
        this.loadFile(`/Sample/學生事務及校園安全組織架構.pdf`);
    },
    methods:{
        loadFile(path){
            this.fileBlob = null;
            if(path){
                this.$http.post("/api/Share/fileDownload",JSON.stringify({
                    model:path,
                }),{
                    headers: { "Content-Type": "application/json" },
                    responseType: "blob" 
                }).then(res => {
                    this.fileBlob = res.body;
                });
            }
        },
        previewFile(){
            if(!this.fileBlob) return;
            const blob = this.fileBlob;
            const type = (blob && blob.type) ? blob.type : '';
            const url = URL.createObjectURL(blob);
            // 如果是 PDF，就直接另開分頁
            if(type.includes('pdf') || /\.pdf$/i.test(this.$route?.query?.file || '')){
                window.open(url, '_blank');
            } else {
                // 其他檔案也允許預覽/下載
                window.open(url, '_blank');
            }
        }
    },
    beforeRouteLeave(to, from, next) {
        this.removeStore(this.$route.name);
		next();
	}
}
</script>
<style>

</style>